/**
 * Shared floor Y for the avatar rig. AvatarModel offsets its group so the
 * rig's bbox bottom aligns with this Y — keeps the wheels/feet on the
 * ground instead of clipping through.
 *
 * Edit mode stays at 0 (matches the floor grid). Live mode's
 * The environment splat writes the splat-detected floor here once available.
 *
 * `lift` is the SECOND term in that placement, and the reason it lives here
 * rather than being written straight onto the group: the floor snap re-asserts
 * `group.position.y` every time the floor moves (environment swap, floor
 * override), so a gizmo that assigned Y directly would be silently reset. The
 * two writers compose instead — floor owns the baseline, the gizmo owns the
 * offset from it — which is what makes vertical drag on the avatar honest
 * rather than a value that disappears on the next environment change.
 */
let y = 0
let lift = 0
const listeners = new Set()

function notify() {
  for (const fn of listeners) fn(y)
}

export const avatarFloor = {
  getY() { return y },
  setY(v) {
    if (!Number.isFinite(v) || v === y) return
    y = v
    notify()
  },
  /** Vertical offset the transform gizmo / inspector adds on top of the floor. */
  getLift() { return lift },
  setLift(v) {
    if (!Number.isFinite(v) || v === lift) return
    lift = v
    notify()
  },
  subscribe(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
  },
}

if (typeof window !== 'undefined') window.__AVATAR_FLOOR__ = avatarFloor
